export const useHMSPeerId = peerId => ({
  externalPeerId: peerId,
});
